module.exports = "/images/creditcard.svg";